<script>
import {client as columns} from "../../tables"

export default {
  data() {
    return {
      columns,
      form: this.$form.createForm(this),
      loading: false,
      expand: false,
      visible: false,
      processing: false,
      client: '',
      hash: '',
      email: '',
      items: {},
      stateChanging: [],
      filters: {
        q: null,
        page: 1,
        per_page: 10,
      }
    }
  },
  created() {
    this.items = this.getDefaultPagination()
    this.filters = _.merge(this.filters, this.$hyperion.request)
    this.getItems()
  },
  computed: {
    pageSize() {
      return parseInt(this.items.per_page)
    }
  },
  methods: {
    tableChanged(pagination) {
      this.filters.page = pagination.current
      this.filters.per_page = pagination.pageSize
      this.pushState(this.filters)
      this.getItems()
    },
    handleSubmit(e) {
      e.preventDefault()
      this.pushState(this.filters)
      this.getItems()
    },
    handleReset(e) {
      e.preventDefault()
      this.filters = {
        q: null,
        page: 1
      }
    },
    handleResetPassword(){

      this.processing = true

      let promise

      promise = this.$http.patch(this.routeUri('hyperion.client.reset_password', { client_hash: this.hash }))

      promise.then((response) => this.handleSuccessResponse(response.data))
        .catch((error) => this.handleResponseError(error.response.data.data))
        .finally(() => this.processing = false)
    },
    getItems() {
      this.loading = true
      this.$http.get(this.routeUri('hyperion.client'), {
        params: this.filters
      })
        .then((response) => this.items = response.data)
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.loading = false)
    },
    toggleState(record) {
      this.stateChanging.push(record.hash)
      this.$http.patch(this.routeUri('hyperion.client.patch',  { client_hash: record.hash}), {
        action: 'TOGGLE_STATE'
      })
        .then(() => this.onSuccessChangingState(record))
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.onFinishedChangingState(record))
    },
    onSuccessChangingState(record) {
      let index = this.items.data.findIndex(i => i.hash === record.hash)
      if (index > -1) {
        this.items.data[index].is_active = !record.is_active
      }
    },
    onFinishedChangingState(record) {
      let index = this.stateChanging.indexOf(record.hash)
      if (index > -1) {
        this.stateChanging.splice(index, 1)
      }
    },
    resetPassword(hash, client, email){
      this.visible = true
      this.client = client
      this.hash = hash
      this.email = email
    },
    close(){
      this.visible = false
      this.client = ''
      this.hash = ''
      this.email = ''
    },
    handleSuccessResponse(data) {
      this.$notification.success({
        message: 'Saved!',
        description: 'Data has been successfully saved!'
      })

      this.close()
    },
    handleResponseError(data) {
      this.form.setFields(_.mapValues(data, function (item, key) {
        return {
          errors: item.map(function (val) {
            return {
              field: key,
              message: val
            }
          })
        }
      }))

      this.$notification.error({
        message: "Failed to validate data",
        description: "We are unable to validate your request."
      })
    }
  }
}
</script>
<template>
  <a-card type="inner" size="small">
    <a-form layout="inline" :form="form" @submit="handleSubmit">
      <a-row :gutter="24" class="form-filter-wrapper" :class="expand ? 'expanded' : ''">
        <a-col :span="6">
          <a-input placeholder="Keyword.." v-model="filters.q">
            <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)"/>
          </a-input>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24" class="text-right">
          <a-button type="primary" html-type="submit" icon="filter"
                    :style="{ display: expand ? 'inline-block' : 'none'}">Filter
          </a-button>
          <a-button class="ml-2" type="dashed" html-type="reset" icon="reload" @click="handleReset"
                    :style="{ display: expand ? 'inline-block' : 'none'}">Reset
          </a-button>

          <a class="ml-2" @click="() => this.expand = !this.expand ">
            Filter
            <a-icon :type="expand ? 'up' : 'down'"/>
          </a>
        </a-col>
      </a-row>
    </a-form>

    <a-divider dashed/>

    <a-skeleton :loading="loading" active>
      <a-table :columns="columns" :dataSource="items.data" rowKey="hash"
               :pagination="{ pageSize: pageSize, current: items.current_page, total: items.total, showSizeChanger: true }"
               @change="tableChanged">

        <div slot="client" slot-scope="record">
          <h4>
            <a-icon type="idcard" /> <a :href="routeUri('hyperion.client.show', {client_hash: record.hash})">{{ record.name }}</a>
            <br>
            <a-icon type="user" /> <small><code>{{ record.username }}</code></small>
          </h4>
        </div>

        <div slot="contact" slot-scope="record">
          <a-button size="small" type="link" :href="'mailto:' + record.email" icon="mail">{{ record.email }}</a-button>

          <template v-if="record.phone_number">
            <br>
            <a-button size="small" type="link" icon="phone" :href="'tel:' + record.phone_number"/>
            {{ record.phone_number }}
          </template>
        </div>

        <div slot="ipAddress" slot-scope="record">
          <ul class="small-font" style="padding-left: 20px;">
            <li v-for="(ip,index) in record.ip_addresses" :key="`ip-${index}`"><strong><code>{{ ip }}</code></strong></li>
          </ul>
        </div>

        <h4 slot="balance" slot-scope="balance"><currency :amount="balance" /></h4>
        <h4 slot="loan" slot-scope="loan"><currency :amount="loan" /></h4>

        <p slot="updatedAt" slot-scope="updated_at" class="text-sm">
          <a-tooltip :title="moment(updated_at).format('YYYY-MM-DD HH:mm:ss')">
            {{ moment(updated_at).fromNow() }}
          </a-tooltip>
        </p>

        <div class="text-center" slot="state" slot-scope="record">
          <template v-if="stateChanging.includes(record.hash)">
            <a-tag style="margin-right: 0;">LOADING</a-tag>
          </template>
          <template v-else>
            <a-popconfirm title="Sure to disable client?" @confirm="() => toggleState(record)" v-if="record.is_active">
              <a-tag style="cursor:pointer; margin-right: 0;" color="#87d068">Active</a-tag>
            </a-popconfirm>
            <a-popconfirm title="Sure to enable client?" @confirm="() => toggleState(record)" v-else>
              <a-tag style="cursor:pointer; margin-right: 0" color="#f50">Inactive</a-tag>
            </a-popconfirm>
          </template>
        </div>

        <div slot="action" slot-scope="record" class="text-right">
          <a-tooltip title="Reset Password">
            <a-button size="small" type="danger" icon="redo" @click="resetPassword(record.hash, record.name, record.email)"/>
          </a-tooltip>

          <a-tooltip title="Edit Client">
            <a-button size="small" type="primary" icon="edit" :href="routeUri('hyperion.client.edit', { client_hash: record.hash })"/>
          </a-tooltip>

          <a-tooltip title="Client Detail">
            <a-button size="small" icon="ellipsis"
                      :href="routeUri('hyperion.client.show', { client_hash: record.hash })"/>
          </a-tooltip>
        </div>
      </a-table>
    </a-skeleton>

    <a-modal
            :visible="visible"
            :destroyOnClose="true"
            :footer="null"
            :closable="false">

            <a-result status="warning" :title="'Apakah Anda yakin akan reset password klien: ' + client"
            :sub-title="'Password akan dikirim ke email berikut: ' + email">
                <template #extra>
                    <a-button type="primary" @click="handleResetPassword" :loading="processing" :disabled="processing">
                        Reset
                    </a-button>
                    <a-button @click="close" :disabled="processing">
                        Tutup
                    </a-button>
                </template>
            </a-result>
        </a-modal>
  </a-card>
</template>
